export const enumerable: MethodDecorator = (t, k, descriptor) => {
    descriptor.enumerable = true;
};
